export enum EUserRoles {
  user = 'user',
  userPlus = 'user_plus',
  accountManager = 'account_manager',
  bookkeeper = 'bookkeeper',
  hr = 'hr',
  superadmin = 'superadmin',
  salesManager = 'sales_manager',
  marketingManager = 'marketing_manager',
  leadAccount = 'lead_account_manager',
  recruiter = 'recruiter',
  leadRecruiter = 'lead_recruiter',
  salesManagerTender = 'sales_manager_tender',
  customer = 'customer',
  staffer = 'staffer',
  leadHR = 'lead_hr',
  cvMaker = 'cv_maker',
  deliveryManager = 'delivery_manager',
  leadDeliveryManager = 'lead_delivery_manager',
}
